<script module>
  export const meta = {
    title: 'Split up into teams',
    teaser:
      'Learn how to create and manage multiple teams in Pausly to enhance\ncollaboration. Customize team settings for sessions and contests, ensuring\ntargeted and efficient engagement within your organization.',
    sort: 3,
  }
</script>

<p>
  In every organization within Pausly, a default team named "All" is established
  from the onset. This integral team is designed to encompass all the users
  within the organization, without the option for deletion or renaming.
</p>
<p>
  However, we understand that for larger organizations, managing a single,
  all-encompassing team may not always be practical. To accommodate the diverse
  needs and structures of large companies, Pausly provides the functionality to
  create additional teams. This flexibility allows organizations to segment
  their users in a way that best supports their operational and collaborative
  needs.
</p>
<p>
  After creating multiple teams, members of your organization can select the
  team or teams they wish to join.
</p>
<h2>Uses of Teams</h2>
<p>
  When initiating a session, employees are presented with the option to share
  the session exclusively with specific teams, rather than with the entire
  organization.
</p>
<p>
  Moreover, the team selection feature is also available when organizing
  contests. This allows for a more refined and targeted engagement, ensuring
  that contests are relevant to the participating teams and fostering a sense of
  community and competition within the targeted groups.
</p>
<p>
  Through the introduction of customizable teams, Pausly aims to support large
  organizations in their quest for efficient, organized, and engaging
  collaboration and communication.
</p>
